import type { ReferralOffer } from '@cobu/types/perk';

import { Strings } from '../constants/Strings';

const toPayout = (value: number | string | null | undefined): string | null => {
  if (value === null || value === undefined || value === '') return null;
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return null;
  return `$${amount.toLocaleString('en-US')}`;
};

export const referralRewardText = (offer: ReferralOffer): string | null => {
  const resident = toPayout(offer.residentPayout);
  if (!resident) return null;
  const friend = toPayout(offer.details?.referredFriendPayout);
  const s = Strings.get().referral.offer;
  return friend
    ? Strings.format(s.rewardDouble, { resident, friend })
    : Strings.format(s.rewardSingle, { resident });
};
